module.exports = __webpack_public_path__ + "img/eight.be5030ca.webp";